import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import blogData from "../../data/blogData";


export default function SingleBlog() {
  const { blogId } = useParams();
  const blog = blogData.find((b) => b.id === parseInt(blogId));
  const [commentForm, setCommentForm] = useState({ name: "", email: "", comment: "" });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [blogId]);

  if (!blog) {
    return (
      <section style={{ padding: "150px 0", textAlign: "center" }}>
        <div className="container">
          <h2>Blog Post Not Found</h2>
          <p style={{ color: "#666", marginBottom: "20px" }}>
            The blog post you're looking for doesn't exist.
          </p>
          <Link to="/blog" className="btn btn-primary" style={{ borderRadius: "50px", padding: "12px 30px" }}>
            View All Posts
          </Link>
        </div>
      </section>
    );
  }

  const relatedPosts = blogData.filter((b) => b.id !== blog.id).slice(0, 3);

  return (
    <>
      {/* ========== BREADCRUMBS ========== */}
      <section className="breadcrumbs">
        <div className="container">
          <ol>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/blog">Blog</Link></li>
            <li>{blog.title}</li>
          </ol>
          <h2>{blog.title}</h2>
        </div>
      </section>

      {/* ========== BLOG DETAIL ========== */}
      <section id="blog" className="blog">
        <div className="container">
          <div className="row">

            {/* ========== LEFT: Blog Content ========== */}
            <div className="col-lg-8 entries">
              <article className="entry entry-single">

                <div className="entry-img">
                  <img src={blog.image} alt={blog.title} className="img-fluid" />
                </div>

                <h2 className="entry-title">
                  <span>{blog.title}</span>
                </h2>

                <div className="entry-meta">
                  <ul>
                    <li className="d-flex align-items-center">
                      <i className="bi bi-person" /> <span>{blog.author}</span>
                    </li>
                    <li className="d-flex align-items-center">
                      <i className="bi bi-clock" /> <time>{blog.date}</time>
                    </li>
                    <li className="d-flex align-items-center">
                      <i className="bi bi-chat-dots" /> <span>{blog.comments} Comments</span>
                    </li>
                  </ul>
                </div>

                <div className="entry-content">
                  <p>{blog.excerpt}</p>
                  <p>{blog.content}</p>

                  {/* Sample content blocks */}
                  <blockquote>
                    <p>
                      Technology is best when it brings people together. At SDtech Solutions,
                      we believe in building digital experiences that create lasting impact.
                    </p>
                  </blockquote>

                  <p>
                    Whether you're a startup looking for your first website or an enterprise
                    seeking digital transformation, our team has the expertise and passion to
                    deliver solutions that exceed your expectations.
                  </p>
                </div>

                {/* Categories & Tags */}
                <div className="entry-footer">
                  <i className="bi bi-folder" />
                  <ul className="cats">
                    <li><span>{blog.category}</span></li>
                  </ul>
                  <i className="bi bi-tags" />
                  <ul className="tags">
                    {blog.tags.map((tag, index) => (
                      <li key={index}><span>{tag}</span></li>
                    ))}
                  </ul>
                </div>
              </article>

              {/* ========== AUTHOR BIO ========== */}
              <div className="blog-author d-flex align-items-center">
                <img
                  src="img/blog/blog-author.jpg"
                  className="rounded-circle float-left"
                  alt="SDtech Team"
                />
                <div>
                  <h4>SDtech Team</h4>
                  <div className="social-links">
                    <a href="https://twitter.com/" target="_blank" rel="noreferrer">
                      <i className="bi bi-twitter" />
                    </a>
                    <a href="https://facebook.com/" target="_blank" rel="noreferrer">
                      <i className="bi bi-facebook" />
                    </a>
                    <a href="https://instagram.com/" target="_blank" rel="noreferrer">
                      <i className="bi bi-instagram" />
                    </a>
                    <a href="https://linkedin.com/" target="_blank" rel="noreferrer">
                      <i className="bi bi-linkedin" />
                    </a>
                  </div>
                  <p>
                    The SDtech Solutions team brings you the latest insights in technology,
                    digital marketing, and business growth strategies. Stay tuned for more!
                  </p>
                </div>
              </div>

              {/* ========== COMMENT FORM ========== */}
              <div className="reply-form">
                <h4>Leave a Reply</h4>
                <p>Your email address will not be published. Required fields are marked *</p>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    alert("Comment submitted! (Connect to backend for real functionality)");
                    setCommentForm({ name: "", email: "", comment: "" });
                  }}
                >
                  <div className="row">
                    <div className="col-md-6 form-group">
                      <input
                        name="name"
                        type="text"
                        className="form-control"
                        placeholder="Your Name*"
                        value={commentForm.name}
                        onChange={(e) => setCommentForm({ ...commentForm, name: e.target.value })}
                        required
                      />
                    </div>
                    <div className="col-md-6 form-group">
                      <input
                        name="email"
                        type="email"
                        className="form-control"
                        placeholder="Your Email*"
                        value={commentForm.email}
                        onChange={(e) => setCommentForm({ ...commentForm, email: e.target.value })}
                        required
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col form-group">
                      <textarea
                        name="comment"
                        className="form-control"
                        placeholder="Your Comment*"
                        rows={5}
                        value={commentForm.comment}
                        onChange={(e) => setCommentForm({ ...commentForm, comment: e.target.value })}
                        required
                      />
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary">
                    Post Comment
                  </button>
                </form>
              </div>
            </div>

            {/* ========== RIGHT: Sidebar ========== */}
            <div className="col-lg-4">
              <div className="sidebar">

                <h3 className="sidebar-title">Recent Posts</h3>
                <div className="sidebar-item recent-posts">
                  {blogData.slice(0, 5).map((post) => (
                    <div className="post-item clearfix" key={post.id}>
                      <img src={post.image} alt={post.title} />
                      <h4><Link to={`/blog/${post.id}`}>{post.title}</Link></h4>
                      <time>{post.date}</time>
                    </div>
                  ))}
                </div>

                <h3 className="sidebar-title">Tags</h3>
                <div className="sidebar-item tags">
                  <ul>
                    {[...new Set(blogData.flatMap((b) => b.tags))].map((tag, index) => (
                      <li key={index}><span>{tag}</span></li>
                    ))}
                  </ul>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ========== RELATED POSTS ========== */}
      <section style={{ padding: "50px 0" }}>
        <div className="container">
          <header className="section-header">
            <h2>Related Posts</h2>
          </header>
          <div className="row gy-4">
            {relatedPosts.map((post, index) => (
              <div className="col-lg-4 col-md-6" key={post.id} data-aos="fade-up" data-aos-delay={100 + index * 100}>
                <div className="entry">
                  <div className="entry-img">
                    <img src={post.image} alt={post.title} className="img-fluid" />
                  </div>
                  <h2 className="entry-title">
                    <Link to={`/blog/${post.id}`}>{post.title}</Link>
                  </h2>
                  <div className="entry-content">
                    <p>{post.excerpt}</p>
                    <div className="read-more">
                      <Link to={`/blog/${post.id}`}>Read More</Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}